'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import NavSidebar from '@/components/NavSidebar';
import { createFeedback } from '@/lib/actions';

export default function NewFeedbackPage() {
  const router = useRouter();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const fd = new FormData(e.currentTarget);
    await createFeedback(fd);
    router.push('/feedback');
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex">
      <NavSidebar activePath="/feedback" />

      <main className="flex-1 p-8 overflow-y-auto">
        <div className="max-w-xl">
          <h2 className="text-4xl font-serif font-bold text-white mb-2 italic">New Feedback</h2>
          <p className="text-slate-400 italic mb-8">Tell me what you think!</p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">Your Name</label>
              <input
                name="name"
                required
                className="w-full bg-slate-900 border border-slate-700 rounded-xl px-4 py-3 text-slate-200 focus:outline-none focus:border-purple-500/50"
              />
            </div>

            <div>
              <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">Type</label>
              <select
                name="type"
                required
                className="w-full bg-slate-900 border border-slate-700 rounded-xl px-4 py-3 text-slate-200 focus:outline-none focus:border-purple-500/50"
              >
                <option value="feature">Feature Request</option>
                <option value="bug">Bug Report</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">Description</label>
              <textarea
                name="description"
                required
                rows={5}
                className="w-full bg-slate-900 border border-slate-700 rounded-xl px-4 py-3 text-slate-200 focus:outline-none focus:border-purple-500/50 resize-y"
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="px-8 py-3 bg-purple-600 hover:bg-purple-500 disabled:opacity-50 rounded-xl font-bold transition-colors"
            >
              {submitting ? 'Submitting...' : 'Submit Feedback'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
